export default __webpack_public_path__ + "static/media/Navroop_K._Sahdev_AHV_In_Moms_We_Trust.7db9dee7.jpg";